var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 2.21484H7.24121V2.53878H8.35239V2.21484Z",
    fill: "#20E89C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99756 2.91602H7.23828V3.23995H8.99756V2.91602Z",
    fill: "#20E89C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35044 3.61523H7.23926V3.93917H8.35044V3.61523Z",
    fill: "#20E89C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34946 4.31055H7.23828V4.63448H8.34946V4.31055Z",
    fill: "#20E89C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99952 5.0166H7.24023V5.34054H8.99952V5.0166Z",
    fill: "#20E89C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 5.71387H7.24121V6.0378H8.35239V5.71387Z",
    fill: "#20E89C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35142 6.41406H7.24023V6.738H8.35142V6.41406Z",
    fill: "#20E89C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 7.11426H7.23926V7.43819H8.99854V7.11426Z",
    fill: "#20E89C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 7.81641H7.24121V8.14034H8.35239V7.81641Z",
    fill: "#20E89C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 8.51953H7.24121V8.84347H8.35239V8.51953Z",
    fill: "#20E89C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 9.21484H7.23926V9.53878H8.99854V9.21484Z",
    fill: "#20E89C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85 17.6C5.9763 17.6 7.7 15.8763 7.7 13.75C7.7 12.6098 6.83764 11.295 6.05 10.5901V2.2C6.05 0.984974 5.06503 0 3.85 0C2.63497 0 1.65 0.983536 1.65 2.19856V10.5901C0.652584 11.2858 0 12.4417 0 13.75C0 15.8763 1.7237 17.6 3.85 17.6Z",
    fill: "#20E89C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.66602,
    cy: 13.8418,
    r: 1.375,
    fill: "#213242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/TemperatureIcon.a77caeba3286cc1b1c1c299554ef5ba7.svg";
export { ForwardRef as ReactComponent };